
// src/utils/tabStorage.ts
export const getTabId = (): string => {
  const existing = sessionStorage.getItem("tabId");
  if (existing) return existing;
  const id = crypto.randomUUID(); // stable for this tab until it closes
  sessionStorage.setItem("tabId", id);
  return id;
};

export const setTabItem = (key: string, value: unknown) => {
  const tabId = getTabId();
  sessionStorage.setItem(`${key}:${tabId}`, JSON.stringify(value));
};

export const getTabItem = <T = unknown>(key: string): T | undefined => {
  const tabId = getTabId();
  const raw = sessionStorage.getItem(`${key}:${tabId}`);
  return raw ? (JSON.parse(raw) as T) : undefined;
};

export const removeTabItem = (key: string) => {
  const tabId = getTabId();
  sessionStorage.removeItem(`${key}:${tabId}`);
};
